import { Link } from 'react-router-dom';
import { i18n as i } from '../../../i18n';
import Exception from '../../../components/Exception';

function NotFound(props: any) {
  return (
    <Exception
      type="404"
      desc={i('抱歉，你访问的页面不存在')}
      style={{ minHeight: 500, height: '80%' }}
      linkElement={Link}
      {...props}
    />
  );
} 

export default NotFound;
